import React from "react";
import "./PublicationArticleEmbed.css";

type PublicationArticleEmbedProps = {
  title: string;
  articleUrl: string;
};

const PublicationArticleEmbed: React.FC<PublicationArticleEmbedProps> = ({
  title,
  articleUrl,
}) => {
  return (
    <div className="publication-article-embed">
      <iframe
        className="publication-article-embed__frame"
        src={articleUrl}
        title={title}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allow="fullscreen; autoplay; clipboard-read; clipboard-write"
      />
      <div className="publication-article-embed__footer">
        <p className="publication-article-embed__hint">
          Some sites block embedded previews. If the article does not appear,
          open it in a new tab.
        </p>
        <a
          href={articleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn publication-article-embed__btn"
        >
          View article on original website
        </a>
      </div>
    </div>
  );
};

export default PublicationArticleEmbed;
